module.exports = __webpack_public_path__ + "static/media/ff.397a0b76.pdf";